export default "__VITE_ASSET__51aBEPhm__"